export default "__VITE_ASSET__9b5953aa__"